module.exports = __webpack_public_path__ + "static/media/natours-min.01e7f4cf.png";